import { jsx, jsxs } from "react/jsx-runtime";
function CloseIcon(props) {
    return /*#__PURE__*/ jsx("span", {
        ...props,
        children: /*#__PURE__*/ jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M2 2L10 10",
                    stroke: "currentColor",
                    "stroke-width": "0.75",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M2 10L10 2",
                    stroke: "currentColor",
                    "stroke-width": "0.75",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                })
            ]
        })
    });
}
export { CloseIcon as default };
